import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "users" };
const _hoisted_2 = { class: "data-table__value-text" };
const _hoisted_3 = {
    key: 0,
    class: "users__you"
};
import { onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from "vue-router";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import DataTable from "@astina/paloma-common-ui/src/components/DataTable.vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import customerRepository from "@astina/paloma-shop-common-ui/src/services/CustomerRepository";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import DeleteUser from "../commands/DeleteUser";
import env from '../services/AppEnv';
export default /*@__PURE__*/ _defineComponent({
    __name: 'UsersView',
    setup(__props) {
        const router = useRouter();
        const grid = ref(null);
        const source = ref(customerRepository.getUsersGridItemsSource());
        const searchRequest = ref({
            query: null,
            filters: [],
        });
        onMounted(() => {
            customerRepository.getUserGridConfig()
                .then((gridParam) => {
                grid.value = gridParam;
            });
            events.$on('command.delete_user.success', loadUsers);
            events.$on('command.save_user.success', loadUsers);
        });
        onUnmounted(() => {
            events.$off('command.delete_user.success', loadUsers);
            events.$off('command.save_user.success', loadUsers);
        });
        function loadUsers() {
            events.$emit('users.refresh');
        }
        function activateItem(user) {
            router.push({ name: 'config_users_user', params: { id: user.id } }).catch(() => {
            });
        }
        function userDeletable(user) {
            return !isMe(user);
        }
        function isMe(user) {
            return env.user.username === user.attributes['username'];
        }
        function deleteUserCommand(user) {
            return new DeleteUser(user.id);
        }
        function closeView() {
            router.push({ name: 'config_users' });
        }
        function prevItem() {
            events.$emit('users.nav-prev');
        }
        function nextItem() {
            events.$emit('users.nav-next');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !grid.value
                }, null, 8, ["loading"]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                (grid.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(DataTable, {
                            name: "users",
                            "search-request": searchRequest.value,
                            grid: grid.value,
                            source: source.value,
                            onActivateItem: activateItem
                        }, {
                            actions: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                    to: { name: 'config_users_create' },
                                    class: "button button--primary"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(Icon, { name: "plus" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('user.create')), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            "list-item": _withCtx((props) => [
                                _createVNode(_component_router_link, {
                                    to: { name: 'config_users_user', params: { id: props.item.id } },
                                    class: "data-table__value"
                                }, {
                                    default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("span", { class: "data-table__value-topic" }, _toDisplayString(props.item.topic), 513), [
                                            [_vShow, props.item.topic]
                                        ]),
                                        _cache[0] || (_cache[0] = _createTextVNode()),
                                        _createElementVNode("span", _hoisted_2, [
                                            _createTextVNode(_toDisplayString(props.item.title) + " ", 1),
                                            (isMe(props.item))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "\n                                (" + _toDisplayString(_ctx.$t('user.you')) + ")\n                            ", 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _: 2
                                }, 1032, ["to"])
                            ]),
                            "item-actions": _withCtx((props) => [
                                _createVNode(_component_router_link, {
                                    to: { name: 'config_users_edit', params: { id: props.item.id } },
                                    class: "button button--link",
                                    href: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(Icon, { name: "edit" })
                                    ]),
                                    _: 1
                                }, 8, ["to"]),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                (userDeletable(props.item))
                                    ? (_openBlock(), _createBlock(CommandButton, {
                                        key: 0,
                                        command: deleteUserCommand(props.item),
                                        classes: ['button', 'button--link'],
                                        label: ""
                                    }, null, 8, ["command"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }, 8, ["search-request", "grid", "source"]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createVNode(_component_router_view, {
                            onClose: closeView,
                            onNext: nextItem,
                            onPrev: prevItem
                        })
                    ], 64))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
